import { SVGProps, Ref, forwardRef } from 'react'
const SvgHourglass = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.039 5.478C6.595 8.687 8.549 10.885 12 12c3.452-1.115 5.406-3.313 5.962-6.522a1.5 1.5 0 0 0-1.491-1.728H7.53a1.5 1.5 0 0 0-1.491 1.728v0ZM3.75.75h16.5M7.53 20.25a1.499 1.499 0 0 1-1.491-1.727C6.595 15.314 8.549 13.116 12 12c3.452 1.116 5.406 3.314 5.962 6.523a1.501 1.501 0 0 1-1.491 1.727H7.53ZM3.75 23.25h16.5"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHourglass)
export default ForwardRef
